export default __webpack_public_path__ + "static/media/team.fc3ac9f4.svg";